import React, {Component} from 'react';
import {TYPE_MAP,TYPE_MAP_VIEW,WELL_CHOSEN_MAP} from '../../../utils/questionType';
import {Rate,Tooltip} from 'antd';
import {ONLINESTATUS} from '../../../utils/questionManageType';
import Footer from '../exercise/Footer';

const $ = require('$');
const MathQuill = require('MathQuill');

const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
    }
    toggleAnswer = (val, e) => {
        // val && cnzz.statistics('PC端作业详情页', 2, '展开答案'); /** 打点统计 */
        e.stopPropagation();
        this.setState({visible: val});
    };
    componentDidMount() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            })
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
        if(this.props.data.subject==='0'){
            this.setState({visible:true})  //数学题默认答案显示
        }
    }


    componentDidUpdate() {
        $('.mathquill-embedded-latex', this.refs.viewer)
            .removeAttr('style')
            .each(function (index, item) {
                // 然而, 我们这里并不是可编辑的
                MQ.StaticMath(item);
            });
        $('.math_reading', this.refs.viewer).off();
        $('.inner_audio', this.refs.viewer) && $('.inner_audio', this.refs.viewer).off().on('click', () => {
            $('.math_reading', this.refs.viewer)[0].play();
            $('.inner_audio', this.refs.viewer).addClass('inner-audio-play');
        });
        $('.math_reading', this.refs.viewer) && $('audio', this.refs.viewer).bind('ended', () => {
            $('.inner_audio', this.refs.viewer).removeClass('inner-audio-play');
        });
    }

    createHtml = str => ({__html: str ? str : `&nbsp;`});


    render() {
        const {visible} = this.state;
        let originData = this.props.data;
        if(this.props.errorAnswer){originData.answer = this.props.errorAnswer}//题目检错页显示的是错的的答题答案

        const {num, children} = this.props;
        let data = originData;
        let stem = JSON.parse(data.stem)
        let item_list = data.item_list.map((d)=>{let item = JSON.parse(d.item);item.code = d.code;return item})
        return (
            <div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><p className="math_text">{`${num + 1}、`}</p></div>}
                    {/*<div className="exercise-con" dangerouslySetInnerHTML={this.createHtml(data.stem)}/>*/}
                    <div className="exercise-con" >
                        <div>
                            音频：
                            <div style={{textAlign:'center',position:'relative',overflow:'hidden',minHeight:70}}>
                                <div style={{position:'absolute',left:'0',padding:'10px'}}>
                                    <div className={'video_cover_img_preview'} style={{textAlign:'left',position:'relative',width:160,minHeight:70}}>
                                        {
                                            stem.audio_url&&
                                            <audio  src={stem.audio_url} controls="controls">您的浏览器不支持</audio>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div style={{marginBottom:10}}>
                                选项：
                            </div>

                            {
                                item_list&&item_list.length&&
                                item_list.map((item, key) =>{
                                        return <div key={key} style={{marginBottom:0}}>
                                            <div style={{display:'inline-block', width:50,fontSize:14,color:'#999'}}>
                                                {item.code}
                                            </div>

                                            <div style={{fontSize:14,display:'inline-block'}}>
                                                <div style={{display:'inline-block', width:200,marginBottom:10}}>
                                                    单词：{item.text}
                                                </div>
                                                <div style={{display:'inline-block', width:200,marginBottom:10}}>
                                                    类型：{item.type==='text'?'文本':'图片'}
                                                </div>
                                                图片：
                                                <img src={item.image_url} alt="" style={{maxHeight:60}} onClick={()=>{this.setState({modalSrc:item.image_url})}}/>
                                            </div>
                                        </div>
                                    }

                                )

                            }
                        </div>
                    </div>

                </div>
                <div className="exercise-footer">
                    {
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span style={{fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.answer)}/>
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                            {
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }

                        </Footer>
                    </div>
                </div>
            </div>


        )
    }
}


export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/nlselect/viewForView.js